<template>

  <nav class="ms-auto" role="navigation">
    <ul class="navbar-nav" aria-label="lower navigation bar">
      <li v-if="!administrator && can('vitals:read')" class="nav-item"><base-link class="nav-link" :to="'/vitalsGroup/all'" data-toggle="collapse" data-target=".navbar-collapse.show">Vitals</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/currentProviders'" data-toggle="collapse" data-target=".navbar-collapse.show">Providers</base-link></li>
      <li v-if="!administrator && can('procedures:read')" class="nav-item"><base-link class="nav-link" :to="'/currentProcedures'" data-toggle="collapse" data-target=".navbar-collapse.show">Procedures</base-link></li>
      <li v-if="!administrator && can('diagnoses:read')" class="nav-item"><base-link class="nav-link" :to="'/currentDiagnosis'" data-toggle="collapse" data-target=".navbar-collapse.show">Diagnoses</base-link ></li>
      <li v-if="!administrator && can('medications:read')" class="nav-item"><base-link class="nav-link" :to="'/currentMedications'" data-toggle="collapse" data-target=".navbar-collapse.show">Medication</base-link ></li>
      <li v-if="!administrator && can('allergies:read')" class="nav-item"><base-link class="nav-link" :to="'/allergy'" data-toggle="collapse" data-target=".navbar-collapse.show">Allergies</base-link></li>
      <li v-if="administrator" class="nav-item dropdown-li"><base-link class="nav-link" :to="'/currentNurse'" data-toggle="collapse" data-target=".navbar-collapse.show">Nurses</base-link >
         <ul class="dropdown-li-ul" aria-label="dropdown">
         <!--- <li class="dropdown-li-ul-li"><router-link to="/currentNurse" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Add Nurse</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/user/verifynurse" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Verify Nurses</router-link></li>-->
          <li class="dropdown-li-ul-li"><router-link to="/user/nursesettings" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Nurse Settings</router-link></li>
         </ul>
      </li>
      <li v-if="administrator" class="nav-item dropdown-li"><base-link class="nav-link" :to="'/patients'" data-toggle="collapse" 
        data-target=".navbar-collapse.show">Patients</base-link ></li>
      <li v-if="administrator" class="nav-item"><base-link class="nav-link" :to="'/professional-notes'" data-toggle="collapse" data-target=".navbar-collapse.show">Notes</base-link></li>
        <li v-if="administrator" class="nav-item dropdown-li "><base-link class="nav-link" :to="'/providers/alliedprofessional'" data-toggle="collapse" 
          data-target=".navbar-collapse.show">Allied Professional </base-link ></li>
          <li v-if="administrator" class="nav-item dropdown-li "><base-link class="nav-link" :to="'/nurse/homehealthaide'" data-toggle="collapse" 
            data-target=".navbar-collapse.show">Home Health Aide </base-link ></li>
            <li v-if="administrator" class="nav-item dropdown-li "><base-link class="nav-link" :to="'/scheduling'" data-toggle="collapse" 
              data-target=".navbar-collapse.show">Scheduling  </base-link ></li>
      <li v-if="administrator || platformOperator" class="nav-item dropdown-li"><base-link class="nav-link" :to="'/administration'" data-toggle="collapse"
        data-target=".navbar-collapse.show">Administration</base-link></li>
      <li v-if="!administrator" class="nav-item dropdown-li">
        <a class="nav-link name" >Historical<font-awesome-icon :icon="['fas', 'caret-down']" /></a>
        <ul class="dropdown-li-ul" aria-label="dropdown">
          <li class="dropdown-li-ul-li"><router-link to="/providers" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Providers</router-link></li>
          <li v-if="can('procedures:read')" class="dropdown-li-ul-li"><router-link to="/procedureKinds" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Procedures</router-link></li>
          <li class="dropdown-li-ul-li"><router-link to="/labKinds" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Labs</router-link></li>
          <li v-if="can('diagnoses:read')" class="dropdown-li-ul-li"><router-link to="/diagnosis" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Diagnoses</router-link></li>
          <li v-if="can('medications:read')" class="dropdown-li-ul-li"><router-link to="/medication" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Medications</router-link></li>
          <li v-if="can('immunizations:read')" class="dropdown-li-ul-li"><router-link to="/vaccination" @click="closeNavbar" data-toggle="collapse"
              data-target=".navbar-collapse.show">Vaccinations</router-link></li>
        </ul>
      </li>
      <li v-if="!administrator && can('documents:read')" class="nav-item"><base-link class="nav-link" :to="'/reports'" data-toggle="collapse" data-target=".navbar-collapse.show">Reports</base-link></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/cdas'" data-toggle="collapse" data-target=".navbar-collapse.show">CDAs</base-link></li>
      <li class="nav-item"><base-link class="nav-link" :to="'/pdfs'" data-toggle="collapse" data-target=".navbar-collapse.show">Documents</base-link ></li>
      <li v-if="!administrator && can('documents:write')" class="nav-item"><base-link class="nav-link" :to="'/data-upload'" data-toggle="collapse" data-target=".navbar-collapse.show">Upload Data</base-link ></li>
      <li v-if="!administrator" class="nav-item"><base-link class="nav-link" :to="'/watch'" data-toggle="collapse" data-target=".navbar-collapse.show">Trend Labs</base-link></li>
      <li v-if="!administrator && can('devices:read')" class="nav-item"><base-link class="nav-link" :to="'/user/devices'" data-toggle="collapse" data-target=".navbar-collapse.show">Devices</base-link></li>
      <li v-if="administrator" class="nav-item"><a class="nav-link" href="#" data-toggle="collapse" data-target=".navbar-collapse.show" @click.prevent="openBillingNav">Billing</a></li>
      <li v-if="!administrator && can('billing:read')" class="nav-item"><base-link class="nav-link" :to="'/cpt'" data-toggle="collapse" data-target=".navbar-collapse.show">CPT</base-link></li>
      <li v-if="viewingPatientChart && !administrator && can('contacts:read')" class="nav-item"><base-link class="nav-link" :to="'/user/contact'" data-toggle="collapse" data-target=".navbar-collapse.show">Contacts</base-link></li>
    </ul>
  </nav>
</template>

<script>
import BaseLink from './BaseLink.vue'
import { Collapse } from "bootstrap";
import { mapGetters } from "vuex";
import {getAdministrator, isViewingPatientChart} from "@/data/getters";
import { PRIVILEGES } from "@/constants/privileges";
import { assertPrivilegeOrAlert } from "@/utils/privilegeGate";
import { useSessionStore } from "@/stores/session";

  export default {
    name: "NavigationBarBottom",
    components: {
      'base-link': BaseLink
    },
    computed: {
      ...mapGetters('login', {
        allData: "getAllData",
      }),
      administrator: function() {
        return getAdministrator(this.allData);
      },
      /**
       * Whether to offer a destination at all.
       *
       * The split above is `administrator` / `!administrator`, which is an
       * account *type*, not authority. It is right for the two ends of the
       * range and wrong for everyone in between: an Allied Professional,
       * Geriatric Care Manager or Contact is `!administrator`, so they were
       * offered Vitals, Procedures, Diagnoses, Medications, Devices and CPT —
       * none of which their role grants. The API refused each one correctly
       * with a 403, and the legacy bridge turns a 403 into an empty result set
       * so the old call sites reach their "nothing here" branch instead of
       * crashing. The user sees an empty grid, which reads as *this patient has
       * no medications* rather than *you may not see medications*.
       *
       * Gating the entry point is the honest fix: don't offer what the server
       * will refuse. This is UX only — the API enforces the same permission.
       */
      can() {
        const session = useSessionStore();
        return (permission) => session.can(permission);
      },
      viewingPatientChart() {
        return isViewingPatientChart(this.allData);
      },
      /**
       * A platform operator is not a customer's administrator, so the line
       * above hides Administration from them — and Platform Administration
       * lives under it (Trello nRhCnuT0). Offered on the same two facts the
       * page checks; the API decides.
       */
      platformOperator() {
        const session = useSessionStore();
        return Boolean(session.me?.is_platform_operator) && session.can(PRIVILEGES.PLATFORM_ADMIN);
      },
    },
    methods: {
      openBillingNav() {
        this.closeNavbar();
        if (
          !assertPrivilegeOrAlert(
            PRIVILEGES.VIEW_USE_BILLING_PAGE,
            "You do not have permission to view the billing page."
          )
        ) {
          return;
        }
        this.$router.push("/cptBilling");
      },
      closeNavbar(){
      let navbar = document.querySelector('.navbar-collapse.show');
            if (navbar) {
                new Collapse(navbar, {
                    toggle: false,
                }).hide();
            }
    },
    }
  }
</script>

<style scoped lang="scss">

$color-hover: darken(#ffffff, 10%);

@import "../../../stylesheets/modules/dropdown";

.commBtn {
  background-color: transparent;
  border: none;
}

.navbar-nav {
  font-size: 0.95rem;
  font-family: "Noto Sans", system-ui, sans-serif;
  /* Same wrap as the upper row (NavigationBarTop): a nowrap flex row that
     doesn't fit widens the document and breaks full-width bands below. */
  flex-wrap: wrap;
  justify-content: flex-end;
  row-gap: 2px;

  .nav-link {
    color: #fff;
    border-bottom: 1px solid transparent;
    cursor: pointer;
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 4px;
    transition: background-color 0.15s ease;
    font-weight: 500;

    &:hover {
      background-color: rgba(75, 156, 165, 0.35);
    }
  }
}

.router-link-active {
  border-bottom: 2px solid #cb5f50 !important;
}

  .capitalize {
    text-transform: capitalize;
  }

  .base-link-active {
    border-bottom: 2px solid #cb5f50 !important;
  }

</style>
